module.exports = __webpack_public_path__ + "media/newstyle/images/icon-search-purple-orange-be42bcc34e44f6769443c5f01d6800c7.svg";